import { render, staticRenderFns } from "./EditionButtons.vue?vue&type=template&id=442a9e9a"
import script from "./EditionButtons.vue?vue&type=script&lang=ts"
export * from "./EditionButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports